var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleLinkedIn = function SvgCircleLinkedIn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedIn_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.143,
    cy: 12,
    r: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.344,
    y: 3.213,
    width: 16.2,
    height: 16.723,
    rx: 8.1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.147 17.462h-2.4v-3.88c0-.926-.016-2.117-1.249-2.117-1.25 0-1.441 1.008-1.441 2.05v3.947h-2.4v-7.98h2.304v1.09h.032c.23-.406.564-.741.964-.968.4-.227.853-.338 1.31-.32 2.432 0 2.88 1.651 2.88 3.8v4.378ZM7.948 8.392c-.276 0-.545-.085-.774-.243a1.429 1.429 0 0 1-.513-.645 1.481 1.481 0 0 1-.08-.83c.054-.28.187-.536.382-.737a1.38 1.38 0 0 1 .713-.394c.27-.055.55-.027.805.082.254.109.472.293.625.53a1.471 1.471 0 0 1-.173 1.815 1.39 1.39 0 0 1-.452.312c-.169.072-.35.11-.533.11Zm1.2 9.07H6.745v-7.98h2.403v7.98ZM19.344 3.214H5.539a1.163 1.163 0 0 0-.84.348 1.24 1.24 0 0 0-.355.858v14.31c.003.323.131.631.356.858.224.226.526.351.84.348h13.804c.314.004.616-.121.841-.347.226-.226.354-.536.359-.86V4.42a1.242 1.242 0 0 0-.359-.86 1.165 1.165 0 0 0-.841-.346",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clip-path", {
    id: "linkedIn_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.143,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleLinkedIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-linked-in.ec24619cefbdee819d0d115dad3de436.svg";